import { FC, useEffect, useState } from 'react'
import { useAppSelector } from '../../../../../store/hooks'
import { Language } from '../../../../../features/security/security.slice'
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap'
import { NavItemType, TreeNodeTemplateProps } from '../Navigation.d'
import NavItemDialog from '../NavItemDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'

const TreeNodeTemplate: FC<TreeNodeTemplateProps> = ({
    node,
    options,
    formikProps,
    availablePages,
    setNodes,
}) => {
    const [label, setLabel] = useState<string>(node.label)
    const initData = useAppSelector((state: any) => state.security.initData)
    const defaultLang: Language = initData.languages.default
    const theme = useAppSelector((state) => state.theme.theme)

    useEffect(() => {
        try {
            setLabel(node.translations[defaultLang.locale][node.label])
        } catch (error) {}
    }, [node.translations, defaultLang.locale, node.label])

    return (
        <Row className={`w-100 mx-0 ${options.className}`}>
            <Col className="text-start">
                {node.children ? (
                    <div className="text-700 hover:text-primary">{label}</div>
                ) : (
                    <b className="text-primary">{label}</b>
                )}{' '}
            </Col>
            <Col className="text-end">
                <ButtonGroup>
                    <NavItemDialog
                        item={node}
                        formikProps={formikProps}
                        availablePages={availablePages}
                        button={{
                            variant: theme === 'dark' ? 'dark' : 'light',
                            label: 'Edit',
                        }}
                        setNodes={setNodes}
                    />
                    <NavItemDialog
                        formikProps={formikProps}
                        availablePages={availablePages}
                        button={{
                            variant: theme === 'dark' ? 'dark' : 'light',
                            label: 'New',
                        }}
                        setNodes={setNodes}
                        targetItemKey={node.key}
                    />
                    <Button
                        variant={theme === 'dark' ? 'dark' : 'light'}
                        size="sm"
                        onClick={() => {
                            const removeNodeByKey = (nodes: NavItemType[]) => {
                                return nodes.filter((n) => {
                                    if (n.children) {
                                        n.children = removeNodeByKey(n.children)
                                    }
                                    return n.key !== node.key
                                })
                            }

                            setNodes((prevState) => {
                                const _val = removeNodeByKey(prevState)

                                formikProps.setFieldValue('value', _val)

                                return _val
                            })
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            className="text-danger"
                        />
                    </Button>
                </ButtonGroup>
            </Col>
        </Row>
    )
}

export default TreeNodeTemplate
